import { PaletteMode } from "@mui/material";
import { Dispatch } from "react";

export interface IThemeData {
	mode: PaletteMode;
	color: string;
}

export enum ThemeActionKind {
	CHANGE_DARK_MODE,
	CHANGE_COLOR,
}

export type ThemeAction =
	| {
			action: ThemeActionKind.CHANGE_DARK_MODE;
			payload: PaletteMode;
	  }
	| {
			action: ThemeActionKind.CHANGE_COLOR;
			payload: string;
	  };

export interface IContextData {
	data: IThemeData;
	dispatch: Dispatch<ThemeAction>;
	setDarkMode: (isDark: boolean) => void;
	isDark: () => boolean;
	setColor: (color: string) => void;
	getColor: () => string;
	getListColor: () => string[];
}

export interface IDefaultTheme {
	name: string;
	palette: {
		primary: string;
		secondary: string;
	};
}
